<template>
  <div :class="['komodo-radio-buttons', `komodo-radio-buttons-${name}`]">
    <div :class="['komodo-radio-buttons-options', `komodo-radio-buttons-options-${name}`]">
      <div
        v-for="(option, index) in options"
        :key="`option-${option}`"
      >
        <label class="komodo-radio-buttons__label">
          <input
            v-model="value"
            type="radio"
            :disabled="disabled"
            :name="`option-${name}-${option}`"
            :value="option"
            class="komodo-radio-buttons-option"
            @input="$emit('input', $event.target.value, index)"
          >
          {{ displayOption(option) }}
        </label>
      </div>
    </div>
    <komodo-errors
      v-if="errored && errors.length > 0"
      :errors="errors"
    />
  </div>
</template>

<script lang="ts">
import { toRefs } from 'vue'
import KomodoErrors from 'shared/components/KomodoErrors.vue'
import { enumToSentenceCase } from 'shared/lib/util'

export default {
  name: 'KomodoRadioButtons'
}
</script>

<script setup lang="ts">
interface Props {
  name: string
  value?: string
  options?: string[]
  withEnum?: boolean
  errored?: boolean
  errors?: string[]
  disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  value: undefined,
  options: () => [],
  withEnum: false,
  errored: false,
  errors: () => [],
  disabled: false
})

defineEmits<{
  (e: 'input', value: KeyboardEvent, index: number): void
}>()

const { value } = toRefs(props)

const displayOption = (option: string): string => {
  return props.withEnum ? enumToSentenceCase(option) : option
}
</script>

<style lang="scss" scoped>
.input {
  margin-right: 4px;
}

.komodo-radio-buttons {
  &__label {
    display: flex;
    gap: 8px;
    align-items: center;
  }
}
</style>
